module.exports = ({React,connect})->

  class TrainingProgressTag extends React.Component

    constructor:(props)->
      super(props)
    
    render:->
      <training-progress {...@props.attributes} {...@props.props}></training-progress>
      
  connect((state)->
    toolbars_active:state.toolbars_active
    textedit_active_node:state.textedit_active_node
  )(TrainingProgressTag)